import { useContext, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Cases, DELETE_CONFIRM, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import { Zoom, toast } from "react-toastify";
import { FILE_TYPE, ThemeNo, titleUpdateKey } from "../../../../constant";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import SimpleReactValidator from "simple-react-validator";
import { IconButton } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import { Settings, Trash } from "react-feather";
import TableOrListSettingParent from "./TableOrListSettingParent";
import {
  addUrlImage,
  convertRGBA,
  isCheckValue,
  isEmptyObject,
  removeUrlImage,
  removeUrlKeyInPath,
  rgbColorCreate,
} from "../../../../utils/helper";
import { FILE_UPLOAD_API } from "../apis/SliderApi/SliderApi";
import DeleteSection from "../../../common/DeleteSection";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import { TableOrListStyleFunctiontyleOneReset } from "./TableOrListStyleFunction";
import TableOrListParentPopup from "./TableOrListParentPopup";
import TableOrListingContext from "../../../context/TableOrListingContext/TableOrListingContext";
import {
  deleteTableOrListing,
  getTableOrListing,
  getTableOrListingDetails,
  postTableOrListing,
  putUpdateTableOrListing,
  updateStatus,
} from "../apis/TableOrListingApi/TableOrListingApi";
import TableOrListPopup from "./TableOrListPopup";
import moment from "moment";
import { uploadFileToSpaces } from "../../../apis/dashboardAPi/DeshboardApi";

const TableOrList = (props) => {
  const {
    pageConfigDetails,
    webMasterDetail,
    ByteMiniWeb_Dashboard,
    getData,
    tableOrListingDetail,
    contentMapId,
    contentDetail,
  } = props;
  const { setLoaderShow } = useContext(LoaderContext);
  const { allPopupState, setAllPopupState } = useContext(
    ByteCardBuilderContext
  );
  const { setCloneAlignModal, setAlignFormData, setCloneFormData } = useContext(
    SettingMultiWebContext
  );
  const parentValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const childValidator = useRef(new SimpleReactValidator());
  const {
    apiData: abutUsData,
    setApiData,
    fromData,
    setFormData,
    id,
    setId,
    setIsEdit,
    isEdit,
    formDataParent,
    setFormDataParent,
    settingFormData,
    setSettingFormData,
    childId,
    setChildId,
    theme,
    setTheme,
    setBoxSection,
    setBackImageToggle,
    boxSection,
    collId,
    setCollId,
    isParent,
    setIsParent,
    isBackgroundColor,
    setIsBackgroundColor,
    setImgShow,
    sectionPageName,
    setSectionPageName,
    storeIndex,
    isArrayImg,
    isSingleImg,
  } = useContext(TableOrListingContext);

  const getTableOrListingList = async ({
    parentId = null,
    isClose = false,
    filter,
    sectionTitle,
  }) => {
    try {
      let paramObj = { search: {}, showAll: true };
      if (
        ((parentId && parentId !== null) ||
          (id && isClose === false && isParent === false)) &&
        isParent === false
      ) {
        paramObj["search"] = { parentId: parentId || id };
        setId(parentId || id);
        if (filter?.length) {
          paramObj["search"] = { ...paramObj.search, title: filter };
        }
      } else {
        paramObj["search"] = { parentId: null };
      }
      const { data } = await getTableOrListing(paramObj);
      if (isCheckValue({ value: parentId })) {
        setChildId(parentId);
      }
      if (data.status === 200) {
        if (
          isParent === false &&
          ((parentId && parentId !== null) || id) &&
          isClose === false
        ) {
          setApiData({
            ...abutUsData,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.tableOrListingId,
                Id: elem?.tableOrListingId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                parentId: elem?.parentId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
          setSectionPageName(sectionTitle);
          OpenModalCommonFunc(Cases.TABLE_LIST, setAllPopupState);
        } else if (parentId && parentId !== null) {
          setSectionPageName(sectionTitle);
          OpenModalCommonFunc(Cases.TABLE_LIST, setAllPopupState);
          setApiData({
            ...abutUsData,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.ourClientId,
                Id: elem?.ourClientId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                parentId: elem?.parentId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
        } else {
          setApiData({
            ...abutUsData,
            isLoading: false,
            data: data.payload.data,
          });
        }
        if (isClose && isClose !== false) {
          setIsParent(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * enable disable api call
   * @param {slider id} sliderId
   * @param {status} isActive
   */

  const handleChangeStatus = async (id, isActive, isChild, parentId) => {
    try {
      let body = {
        tableOrListingId: id,
        isActive: isActive ? false : true,
        parentId,
      };
      const { data } = await updateStatus(body);
      if (data.status === 200) {
        if (isChild) {
          getTableOrListingList({ parentId: parentId });
        } else {
          ByteMiniWeb_Dashboard();
        }
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * image upload
   * @param {file} file
   */
  const imageUpload = async (file) => {
    setLoaderShow(true);
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.ABOUT_US);
    // formData.append("file", file);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.ABOUT_US,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        if (isArrayImg) {
          let old = [...fromData.otherData];
          delete fromData.image;
          old[storeIndex]["image"] =
            data.payload.baseUrl + data.payload.imageUrl;

          setFormData((prev) => {
            return {
              ...prev,
              otherData: old,
            };
          });
        } else if (isSingleImg) {
          delete fromData.image;
          setFormData((prev) => {
            return {
              ...prev,
              filePath: data.payload.baseUrl + data.payload.imageUrl,
            };
          });
        }

        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * bhackground image upload
   * @param {file} file
   */
  const backgroundImageUpload = async (file) => {
    setLoaderShow(true);
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.ABOUT_US);
    // formData.append("file", file);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.ABOUT_US,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setSettingFormData((prev) => {
          if (+theme === ThemeNo.ThemeOne) {
            return {
              ...prev,
              ".multipage-table-section.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          }
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };
  /**
   * create and update about us
   */
  const handleSubmit = async () => {
    let newData = {};
    if ((childId >= -1 && isEdit) || (id >= -1 && isEdit)) {
      try {
        newData = {
          ...fromData,
          contentMapId: collId,
          id: childId,
          tableOrListingId: childId,
        };
        if (fromData?.filePath?.length) {
          newData["filePath"] = fromData.filePath
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
        }
        delete newData?.images;
        setLoaderShow(true);
        const { data } = await putUpdateTableOrListing(newData);
        if (data.status === 200) {
          getTableOrListingList({ parentId: id });
          TostMessage({ message: data, type: "success" });
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          hanldenewCreate();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let newData = {
          ...fromData,
          contentMapId: collId,
          parentId: id,
        };
        if (fromData?.filePath?.length) {
          newData["filePath"] = fromData.filePath
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
        }
        delete newData?.images;
        const { data } = await postTableOrListing(newData);
        if (data.status === 200) {
          getTableOrListingList({ parentId: id });
          TostMessage({ message: data, type: "success" });
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          emptyDataReportDownload();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  const handleSubmitSetting = async () => {
    if (id >= -1 && isEdit) {
      try {
        setLoaderShow(true);
        let newData = {
          ...formDataParent,
          contentMapId: collId || contentMapId,
          id: id,
        };
        delete newData.style;
        const { data } = await putUpdateTableOrListing(newData);
        if (data.status === 200) {
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
          OpenModalCommonFunc(Cases.TABLE_LIST_PARENT, setAllPopupState, false);
          emptyDataReportDownload();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let newData = {
          ...formDataParent,
          contentMapId: collId || contentMapId,
        };
        // delete newData.style;
        const { data } = await postTableOrListing(newData);
        if (data.status === 200) {
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
          OpenModalCommonFunc(Cases.TABLE_LIST_PARENT, setAllPopupState, false);
          emptyDataReportDownload();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  const handleSubmitWithValidate = async (formValidationCondition) => {
    let validatorFields;
    if (formValidationCondition === "parentForm") {
      validatorFields = parentValidator.current;
    } else if (formValidationCondition === "childForm") {
      validatorFields = childValidator.current;
    }
    validatorFields.showMessages();

    if (validatorFields.allValid()) {
      try {
        // Process form data based on the formType
        if (formValidationCondition === "parentForm") {
          handleSubmitSetting();
        } else if (formValidationCondition === "childForm") {
          handleSubmit();
        }
        validatorFields.hideMessages();
      } catch (error) {
        // Handle error for form submission
      }
    } else {
      // Force update to display validation messages
      forceUpdate({});
    }
  };

  const handleChangeSettings = async (
    tableOrListingId,
    isThemeEdit = false
  ) => {
    try {
      setLoaderShow(true);
      setId(tableOrListingId);
      setSettingFormData((prev) => {
        return {
          ...prev,
          tableOrListingId,
        };
      });
      const { data } = await getTableOrListingDetails(tableOrListingId);
      if (data.status === 200) {
        const themeCount = data?.payload?.data?.theme;
        let payload = data.payload.data;
        setSectionPageName(payload?.title);
        setTheme(themeCount);
        setImgShow(true);
        let find = [".multipage-table-section"];
        let section = Object.keys(payload.style);
        let foundItem = null;
        for (const key in find) {
          if (section.includes(find[key])) {
            foundItem = find[key];
            break; // If found, exit the loop
          }
        }
        if (
          +themeCount === ThemeNo.ThemeOne &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({
            ...TableOrListStyleFunctiontyleOneReset,
          });
          setBoxSection(false);
          setBackImageToggle(false);
          setIsBackgroundColor(false);
        } else {
          if (
            payload.style?.[foundItem]?.["width"] ||
            payload.style?.[foundItem]?.["margin"] ||
            payload.style?.[foundItem]?.["border-radius"]
          ) {
            setBoxSection(true);
          }
          if (payload.style?.[`${foundItem}.bg-image`]?.["background-image"]) {
            setBackImageToggle(true);
          }
          if (payload.style?.[`${foundItem}`]?.["background-color"]) {
            setIsBackgroundColor(true);
          }
          setSettingFormData((prev) => {
            return {
              ...prev,
              ...payload.style,
              [foundItem]: {
                padding: payload.style?.[foundItem]?.["padding"],
                "background-color": payload.style?.[foundItem]?.[
                  "background-color"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[foundItem]?.["background-color"],
                  })
                  : "",
                width: payload.style?.[foundItem]?.["width"]?.replace(
                  "calc(100% - ",
                  ""
                ),
                margin: payload.style?.[foundItem]?.["margin"],
                "border-radius": payload.style?.[foundItem]?.["border-radius"],
              },
              [`${foundItem}.bg-image`]: {
                "background-image":
                  payload.style?.[`${foundItem}.bg-image`]?.[
                    "background-image"
                  ] !== "" &&
                    payload.style?.[`${foundItem}.bg-image`]?.[
                    "background-image"
                    ] !== null
                    ? removeUrlKeyInPath({
                      urlString:
                        payload.style?.[`${foundItem}.bg-image`]?.[
                        "background-image"
                        ],
                    })
                    : "",
              },
              [`${foundItem}.bg-image::before`]: {
                "background-color": payload.style?.[
                  `${foundItem}.bg-image::before`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem}.bg-image::before`]?.[
                      "background-color"
                      ],
                  })
                  : "",
              },
              [`${foundItem} .section-title-area .section-subtitle`]: {
                ...payload.style?.[
                `${foundItem} .section-title-area .section-subtitle`
                ],
                "background-color": payload.style?.[
                  `${foundItem} .section-title-area .section-subtitle`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .section-title-area .section-subtitle`
                      ]?.["background-color"],
                  })
                  : "",
                color: payload.style?.[
                  `${foundItem} .section-title-area .section-subtitle`
                ]?.["color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .section-title-area .section-subtitle`
                      ]?.["color"],
                  })
                  : "",
              },
              [`${foundItem} .section-title-area .section-title`]: {
                ...payload.style?.[
                `${foundItem} .section-title-area .section-title`
                ],
                color: payload.style?.[
                  `${foundItem} .section-title-area .section-title`
                ]?.["color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .section-title-area .section-title`
                      ]?.["color"],
                  })
                  : "",
              },
              [`${foundItem} .custom-img`]: {
                ...payload.style?.[`${foundItem} .custom-img`],
              },
              [`${foundItem} .table th`]: {
                ...payload.style?.[`${foundItem} .table th`],
                borderColor: payload.style?.[`${foundItem} .table th`]?.[
                  "borderColor"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .table th`]?.[
                      "borderColor"
                      ],
                  })
                  : "",
              },
              [`${foundItem} .table td`]: {
                ...payload.style?.[`${foundItem} .table td`],
                borderColor: payload.style?.[`${foundItem} .table td`]?.[
                  "borderColor"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .table td`]?.[
                      "borderColor"
                      ],
                  })
                  : "",
              },

              custom: payload?.style?.custom,
            };
          });
        }

        if (!isThemeEdit) {
          OpenModalCommonFunc(
            Cases.SETTING_TABLE_LIST_PARENT,
            setAllPopupState
          );
          TostMessage({ message: data, type: "success" });
        }

        setIsEdit(true);
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get details about us
   * @param {id} id
   */
  const handleEdit = async (idAbout, isParent) => {
    try {
      setLoaderShow(true);

      setIsParent(true);
      const { data } = await getTableOrListingDetails(idAbout);

      if (data.status === 200) {
        let payload = data.payload.data;
        if (isParent && isParent !== false) {
          setId(idAbout);
          setSectionPageName(payload?.title);
          setFormDataParent({
            title: payload?.title,
            subTitle: payload?.subTitle,
            slugUrl: payload?.slugUrl,
            contentMapId: payload?.contentMapId,
          });
          setIsEdit(true);
          OpenModalCommonFunc(Cases.TABLE_LIST_PARENT, setAllPopupState);
        } else {
          setChildId(idAbout);
          setIsParent(false);
          setFormData({
            title: payload.title,
            filed1: payload.filed1,
            filed2: payload.filed2,
            filed3: payload.filed3,
            date: payload.date ? moment(payload.date).format("YYYY-MM-DD") : "",
            filePath: payload.filePath
              ? `${process.env.REACT_APP_BUCKET_URL}/${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/${payload.filePath}`
              : "",
            parentId: payload.parentId,
            tableOrListingId: payload.tableOrListingId,
          });
          setIsEdit(true);
          setChildId(payload.tableOrListingId);
        }

        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * delete images
   * @param {id} tableOrListingId
   */
  const handleDelete = async (tableOrListingId) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteTableOrListing(tableOrListingId);
        if (data.status === 200) {
          ByteMiniWeb_Dashboard();
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  const handleAboutUsSubmitSetting = async (
    isRestore = false,
    isClose = true
  ) => {
    if (id >= -1 && isEdit) {
      setLoaderShow(true);
      try {
        let newData;
        if (isRestore) {
          const isConfirm = window.confirm(
            "Are you sure want to restore style ?"
          );
          if (isConfirm) {
            newData = {
              styleRestore: true,
              id: id,
            };
          } else {
            setLoaderShow(false);
            return;
          }
        } else {
          if (+theme === ThemeNo.ThemeOne) {
            newData = {
              ...settingFormData,
              ".multipage-table-section": boxSection
                ? {
                  ...settingFormData?.[".multipage-table-section"],
                  padding: `${settingFormData?.[".multipage-table-section"]?.[
                    "padding"
                  ]
                    ?.split(" ")[0]
                    ?.replace("px", "")}px 0`,
                  width: `calc(100% - ${settingFormData?.[
                    ".multipage-table-section"
                  ]?.["width"]?.replace("rem)", "")}rem)`,
                  margin: `${settingFormData?.[".multipage-table-section"]?.[
                    "margin"
                  ]
                    ?.split(" ")[0]
                    ?.replace("px", "")}px auto`,
                  "border-radius": `${settingFormData?.[
                    ".multipage-table-section"
                  ]?.["border-radius"]?.replace("rem", "")}rem`,
                }
                : {
                  ...settingFormData?.[".multipage-table-section"],
                  padding: `${settingFormData?.[".multipage-table-section"]?.[
                    "padding"
                  ]
                    ?.split(" ")[0]
                    ?.replace("px", "")}px 0`,
                },
              ".multipage-table-section.bg-image": settingFormData?.[
                ".multipage-table-section.bg-image"
              ]?.["background-image"]
                ? {
                  "background-image": settingFormData?.[
                    ".multipage-table-section.bg-image"
                  ]?.["background-image"]
                    ? addUrlImage({
                      urlString: removeUrlImage({
                        urlString:
                          settingFormData?.[
                          ".multipage-table-section.bg-image"
                          ]?.["background-image"],
                      }),
                    })
                    : "",
                }
                : {},
              ".multipage-table-section.bg-image::before": settingFormData?.[
                ".multipage-table-section.bg-image::before"
              ]?.["background-color"]
                ? {
                  "background-color": settingFormData?.[
                    ".multipage-table-section.bg-image::before"
                  ]?.["background-color"]
                    ? rgbColorCreate({
                      rgbString:
                        settingFormData?.[
                        ".multipage-table-section.bg-image::before"
                        ]?.["background-color"],
                    })
                    : "",
                }
                : {},
              ".multipage-table-section .section-title-area": {
                "margin-bottom": `${settingFormData[
                  ".multipage-table-section .section-title-area"
                ]?.["margin-bottom"]?.replace("px", "")}px`,
              },
              ".multipage-table-section .section-title-area .section-subtitle":
              {
                ...settingFormData?.[
                ".multipage-table-section .section-title-area .section-subtitle"
                ],
                "font-size": `${settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["font-size"]?.replace("px", "")}px`,
                "font-weight": `${settingFormData?.[".multipage-table-section .section-title-area .section-subtitle"]?.["font-weight"]}`,
                color: settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".multipage-table-section .section-title-area .section-subtitle"
                      ]?.["color"],
                  })
                  : "",
                "background-color": settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["background-color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".multipage-table-section .section-title-area .section-subtitle"
                      ]?.["background-color"],
                  })
                  : "",
                padding: `${settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["p1"]?.replace("px", "")}px ${settingFormData[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["p2"]?.replace("px", "")}px`,
                p1: `${settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["p1"]?.replace("px", "")}px`,
                p2: `${settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["p2"]?.replace("px", "")}px`,
                "border-radius": `${settingFormData?.[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["border-radius"]?.replace("px", "")}px`,
                "margin-bottom": `${settingFormData[
                  ".multipage-table-section .section-title-area .section-subtitle"
                ]?.["margin-bottom"]?.replace("px", "")}px`,
              },
              ".multipage-table-section .section-title-area .section-title": {
                ...settingFormData?.[".section-title-area .section-title"],
                "font-size": `${settingFormData?.[
                  ".multipage-table-section .section-title-area .section-title"
                ]?.["font-size"]?.replace("px", "")}px`,
                "font-weight": `${settingFormData?.[".multipage-table-section .section-title-area .section-title"]?.["font-weight"]}`,
                color: settingFormData?.[
                  ".multipage-table-section .section-title-area .section-title"
                ]?.["color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".multipage-table-section .section-title-area .section-title"
                      ]?.["color"],
                  })
                  : "",
              },
              ".multipage-table-section .custom-img": {
                ...settingFormData?.[".multipage-table-section .custom-img"],
                width: `${settingFormData[
                  ".multipage-table-section .custom-img"
                ]?.["width"]?.replace("px", "")}px`,
                height: `${settingFormData[
                  ".multipage-table-section .custom-img"
                ]?.["height"]?.replace("px", "")}px`,
                "border-radius": `${settingFormData[
                  ".multipage-table-section .custom-img"
                ]?.["border-radius"]?.replace("%", "")}%`,
              },
              ".multipage-table-section .table th": {
                ...settingFormData?.[".multipage-table-section .table th"],

                border: `${settingFormData?.[
                  ".multipage-table-section .table th"
                ]?.["borderPx"]?.replace("px", "")}px ${settingFormData?.[".multipage-table-section .table th"][
                "borderThik"
                ]
                  } ${rgbColorCreate({
                    rgbString:
                      settingFormData?.[".multipage-table-section .table th"]?.[
                      "borderColor"
                      ],
                  })}`,
                borderPx: `${settingFormData?.[
                  ".multipage-table-section .table th"
                ]?.["borderPx"]?.replace("px", "")}px`,
                borderThik: `${settingFormData?.[".multipage-table-section .table th"]?.["borderThik"]}`,
                borderColor: settingFormData?.[
                  ".multipage-table-section .table th"
                ]?.["borderColor"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".multipage-table-section .table th"
                      ]?.["borderColor"],
                  })
                  : "",
              },
              ".multipage-table-section .table td": {
                ...settingFormData?.[".multipage-table-section .table td"],

                border: `${settingFormData?.[
                  ".multipage-table-section .table td"
                ]?.["borderPx"]?.replace("px", "")}px ${settingFormData?.[".multipage-table-section .table td"][
                "borderThik"
                ]
                  } ${rgbColorCreate({
                    rgbString:
                      settingFormData?.[".multipage-table-section .table td"]?.[
                      "borderColor"
                      ],
                  })}`,
                borderPx: `${settingFormData?.[
                  ".multipage-table-section .table td"
                ]?.["borderPx"]?.replace("px", "")}px`,
                borderThik: `${settingFormData?.[".multipage-table-section .table td"]?.["borderThik"]}`,
                borderColor: settingFormData?.[
                  ".multipage-table-section .table td"
                ]?.["borderColor"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".multipage-table-section .table td"
                      ]?.["borderColor"],
                  })
                  : "",
              },
            };
            if (isBackgroundColor) {
              newData[".multipage-table-section"] = {
                ...newData?.[".multipage-table-section"],
                "background-color": settingFormData[
                  ".multipage-table-section"
                ]?.["background-color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".multipage-table-section"]?.[
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".multipage-table-section.bg-image::before"] = {
                ...newData[".multipage-table-section.bg-image::before"],
                "border-radius": `${settingFormData?.[
                  ".multipage-table-section"
                ]?.["border-radius"]?.replace("rem", "")}rem`,
              };
            }
          }
          const keysToRemove = ["image"];
          function removeKeys(obj, keys) {
            for (const key in obj) {
              if (typeof obj[key] === "object") {
                removeKeys(obj[key], keys);
              } else if (keys.includes(key)) {
                delete obj[key];
              }
            }
          }
          removeKeys(newData, keysToRemove);
          newData = {
            theme,
            style: newData,
            id: id,
          };
        }

        const { data } = await putUpdateTableOrListing(newData);
        if (data.status === 200) {
          if (isClose) {
            OpenModalCommonFunc(
              Cases.SETTING_TABLE_LIST_PARENT,
              setAllPopupState,
              false
            );
            emptyDataReportDownload();
            setBackImageToggle(false);
            setBoxSection(false);
            setBackImageToggle(false);
          }
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * create new about us
   */
  const hanldenewCreate = () => {
    setFormData({
      title: "",
      filed1: "",
      filed2: "",
      filed3: "",
      date: "",
      filePath: "",
    });
    setIsEdit(false);
    setChildId("");
  };

  /**
   * clear data
   */
  const emptyDataReportDownload = () => {
    setIsBackgroundColor(false);
    setBoxSection(false);
    setIsParent(false);
    setBoxSection(false);
    setBackImageToggle(false);
    // setId("");
    setIsEdit(false);
    setChildId("");
    setLoaderShow(false);
    setFormData({
      title: "",
      filed1: "",
      filed2: "",
      filed3: "",
      date: "",
      filePath: "",
    });
    setSettingFormData({});
    // setId("");
    setIsEdit(false);
    setFormDataParent({
      title: "",
      subTitle: "",
      contentMapId: "",
      style: {
        ".multipage-table-section": {
          padding: "50px 0",
          "background-color": { r: 255, g: 255, b: 255, a: 100 },
        },
        ".multipage-table-section.bg-image": {},
        ".multipage-table-section.bg-image::before": {},
        ".multipage-table-section .section-title-area": {
          "margin-bottom": "50px",
        },
        ".multipage-table-section .section-title-area .section-subtitle": {
          "font-size": "16px",
          "font-weight": "600",
          color: { r: 255, g: 73, b: 124, a: 100 },
          "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
          padding: "5px 20px",
          p1: "5px",
          p2: "20px",
          "border-radius": "15px",
          "margin-bottom": "15px",
          display: "inline-block",
        },
        ".multipage-table-section .section-title-area .section-title": {
          "font-size": "44px",
          "font-weight": "600",
          color: { r: 0, g: 0, b: 0, a: 100 },
        },
        ".multipage-table-section .custom-img": {
          width: "40px",
          height: "40px",
          "border-radius": "50%",
        },
        ".multipage-table-section .table th": {
          border: "1px solid rgba(204, 204, 204, 1)",
          borderPx: "1px",
          borderThik: "solid",
          borderColor: { r: 204, g: 204, b: 204, a: 100 },
        },
        ".multipage-table-section .table td": {
          border: "1px solid rgba(204, 204, 204, 1)",
          borderPx: "1px",
          borderThik: "solid",
          borderColor: { r: 204, g: 204, b: 204, a: 100 },
        },
        custom: "",
      },
    });
    forceUpdate({});
    childValidator.current.hideMessages();
  };

  const handleAlignAndCloneSection = ({ isClone = false }) => {
    if (isClone) {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          cloneModal: true,
        };
      });
      setCloneFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          pageConfigDetailsLabel: pageConfigDetails[0]?.label,
          contentDetailName: contentDetail.name,
        };
      });
    } else {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          alignModal: true,
        };
      });
      setAlignFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          label: pageConfigDetails[0]?.label,
        };
      });
    }
  };
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody
            className="support-ticket-font box-border-div"
            style={{ padding: "20px" }}
          >
            <CardBuilderHeaderSection
              addBtnTitle={pageConfigDetails[0]?.label}
              name={pageConfigDetails[0]?.label}
              isAdd={!tableOrListingDetail && true}
              mainEditSection={true}
              ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
              pageId={pageConfigDetails[0]?.pageId}
              openModal={() => {
                setCollId(contentMapId);
                setSectionPageName(modalsName.TABLE_LIST_PARENT);
                setIsParent(true);
                OpenModalCommonFunc(Cases.TABLE_LIST_PARENT, setAllPopupState);
              }}
              isCloneSection={true}
              isAlignSection={true}
              handleAlignAndCloneSection={handleAlignAndCloneSection}
            />
            <Row>
              {tableOrListingDetail && (
                <Col xl="12 xl-50 box-col-6" md="6">
                  <Card className="ecommerce-widget">
                    <CardBody
                      className="support-ticket-font mb-0"
                      style={{ padding: "20px" }}
                    >
                      <div className="col-12">
                        <CardBuilderHeaderSection
                          name={tableOrListingDetail?.title}
                          checked={tableOrListingDetail?.isActive}
                          switchToggle={true}
                          id={tableOrListingDetail?.tableOrListingId}
                          handleChange={handleChangeStatus}
                        />
                        <OpenPopupBtn
                          openPopup={() => {
                            setCollId(contentMapId);
                            getTableOrListingList({
                              parentId: tableOrListingDetail.tableOrListingId,
                              sectionTitle: tableOrListingDetail?.title,
                            });
                          }}
                          name={`Add or View ${tableOrListingDetail?.title}`}
                        />
                      </div>
                      <div className="d-flex justify-content-end ">
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            setCollId(contentMapId);
                            handleEdit(
                              tableOrListingDetail.tableOrListingId,
                              true
                            );
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleDelete(
                              tableOrListingDetail.tableOrListingId,
                              true
                            )
                          }
                        >
                          <Trash />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleChangeSettings(
                              tableOrListingDetail.tableOrListingId
                            );
                          }}
                        >
                          <Settings />
                        </IconButton>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
              <DeleteSection
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
              />
              {/* <OpenPopupBtn
                openPopup={() =>
                  OpenModalCommonFunc(Cases.TABLE_LIST, setAllPopupState)
                }
                name={btnName.TABLE_LIST}
              /> */}
            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* about us parent popup  */}
      <CommonPopup
        open={allPopupState.tableOrListParentPopup}
        close={() => {
          OpenModalCommonFunc(Cases.TABLE_LIST_PARENT, setAllPopupState, false);
          setIsParent(false);
        }}
        modalName={
          sectionPageName ? sectionPageName : modalsName.TABLE_LIST_PARENT
        }
        modalCase={Cases.TABLE_LIST_PARENT}
        handleSubmit={handleSubmitWithValidate}
        show={false}
        edit={false}
        emptyData={emptyDataReportDownload}
        inputData={formDataParent}
        validationForm={"parentForm"}
        content={
          <TableOrListParentPopup
            emptyData={emptyDataReportDownload}
            simpleValidator={parentValidator}
          />
        }
      />

      <CommonPopup
        open={allPopupState.tableOrListingPopup}
        close={() => {
          OpenModalCommonFunc(Cases.TABLE_LIST, setAllPopupState, false);
          setIsParent(false);
        }}
        // apiCall={getAboutUsList}
        modalName={sectionPageName ? sectionPageName : modalsName.TABLE_LIST}
        modalCase={Cases.TABLE_LIST}
        handleSubmit={handleSubmitWithValidate}
        emptyData={emptyDataReportDownload}
        inputData={fromData}
        edit={false}
        validationForm={"childForm"}
        oldTitle={titleUpdateKey.isAboutUs}
        label={titleUpdateKey.TABLE_LIST}
        getData={getData}
        content={
          <TableOrListPopup
            getTableOrListingList={getTableOrListingList}
            handleChangeStatus={handleChangeStatus}
            handleSubmit={handleSubmitWithValidate}
            getData={getTableOrListingList}
            handleEdit={handleEdit}
            imageUpload={imageUpload}
            emptyData={emptyDataReportDownload}
            simpleValidator={childValidator}
            webMasterDetail={webMasterDetail}
          />
        }
      />

      <CommonPopup
        open={allPopupState.tableOrListingSettingPopup}
        close={() =>
          OpenModalCommonFunc(
            Cases.SETTING_TABLE_LIST_PARENT,
            setAllPopupState,
            false
          )
        }
        modalName={
          sectionPageName
            ? sectionPageName
            : modalsName.SETTING_TABLE_LIST_PARENT
        }
        modalCase={Cases.SETTING_TABLE_LIST_PARENT}
        handleSubmit={handleAboutUsSubmitSetting}
        emptyData={emptyDataReportDownload}
        inputData={fromData}
        edit={false}
        content={
          <TableOrListSettingParent
            imageUpload={backgroundImageUpload}
            handleSubmitSetting={handleAboutUsSubmitSetting}
            handleChangeSettings={handleChangeSettings}
          />
        }
      />
    </>
  );
};

export default TableOrList;
